import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Login from './Login';

const ProtectedRoute = ({ children, requiredRole = null, allowedRoles = null }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  // Check role access - support both single role (requiredRole) and multiple roles (allowedRoles)
  let hasAccess = true;
  let requiredRolesDisplay = null;

  if (allowedRoles && Array.isArray(allowedRoles)) {
    // Check if user's role is in the allowed roles array
    hasAccess = allowedRoles.includes(user.role);
    requiredRolesDisplay = allowedRoles.join(', ');
  } else if (requiredRole) {
    // Legacy support: single role check
    hasAccess = user.role === requiredRole;
    requiredRolesDisplay = requiredRole;
  }

  if (!hasAccess) {
    return (
      <div className="container">
        <div className="card text-center">
          <h2>Access Denied</h2>
          <p>You don't have permission to access this page.</p>
          <p>Required role{allowedRoles && allowedRoles.length > 1 ? 's' : ''}: {requiredRolesDisplay}</p>
          <p>Your role: {user.role}</p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
